import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { ListRunningWebTrackerScansResponse } from "../types";

export default function useListRunningWebTrackerScans() {
  return useQuery<ListRunningWebTrackerScansResponse>(
    "list-running-web-tracker-scans",
    async () => {
      const res = await makeRequest<ListRunningWebTrackerScansResponse>(
        "list_running_web_tracker_scans"
      );

      return {
        ...res.data,
        scans: res.data.scans.map((scan) => ({
          ...scan,
          startedAt: new Date((scan.startedAt as unknown) as string),
          stoppedAt: scan.stoppedAt
            ? new Date((scan.stoppedAt as unknown) as string)
            : null,
        })),
      };
    }
  );
}
